import React from "react";
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import { useQuery } from 'react-query';
import { getScheduleByNoc } from "data/Querys";
import Loader from "components/general/Loader";
import NotAvailable from "components/common/NotAvailable";
import NocScheduleTable from "components/common/schedule/NocScheduleTable";
import Label from "components/general/Label";
import PageHeader from "components/common/PageHeader";
import { sortDataByFieldDesc } from "helpers/utils";


const ScheduleByNoc = () => {
  const { mirs_competition, mirs_language, mirs_noc } = useUrlFriendlyToParameters()

  const { data, isError, isLoading } = useQuery(
    {
      queryKey: ['scheduleDataByNOC', mirs_competition, mirs_language, mirs_noc],
      queryFn: getScheduleByNoc,
      refetchInterval: 5000,
      staleTime: 5000,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
      //enabled: !!confCategory
      onError: (error) =>
        console.error(`Something went wrong: ${error.message}`),
    });

  if (isError) { return <NotAvailable />; }
  if (isLoading) { return <Loader />; }
  if (!data?.schedulesByNoc) { return <NotAvailable /> }

  //we need to filter by phase type
  const filteredData = data?.schedulesByNoc?.filter((u) => u.eventUnit.phase.type.match('[13]') )
  
  sortDataByFieldDesc(filteredData, 'startDate', true, true)

  return (
    <>
      <PageHeader title={<Label data="HeaderScheduleByCountry" />} />
      <NocScheduleTable data={data.schedulesByNoc} key={`schedule-${mirs_noc}`} />
    </>
  )

};


export default ScheduleByNoc

